import React from "react";
import { Route, Switch, useRouteMatch } from "react-router";
import { Row } from "antd";

import StoresList from "./StoresList";
// import CohortUserList from "./CohortUserList";

const Stores = (props) => {
  let { path } = useRouteMatch();

  return (
    <Row
      style={{
        width: "100%",
        padding: "40px 25px 70px",
        margin: "60px auto 20px",
        backgroundColor: "#FAFAFA",
      }}
      gutter={[12, 48]}
    >
      <Switch>
        <Route exact path={`${path}`} component={StoresList} />
        {/* <Route exact path={`${path}/:StoreID`} component={CohortUserList} /> */}
        <Route path="*" component={() => <>404 NOT FOUND</>}></Route>
      </Switch>
    </Row>
  );
};

export default Stores;
